<template>
  <div class="hausarzt-programm">
    <div class="newsImg" />
    <div class="hzvText">
      <div class="hzvLogo" /><br>
      Im Hausarztprogramm, auch Hausarztzentrierte Versorgung (HZV) genannt, wählen Patienten ihren Hausarzt als ersten Ansprechpartner in allen Fragen zu ihrer Gesundheit.<br><br>
      Das Hausarztprogramm wurde eingeführt, um Patienten eine bessere und umfassendere medizinische Versorgung anzubieten. Heute ist das Hausarztprogramm fester Bestandteil des Gesundheitswesens.<br><br>
      Mit ihrer Teilnahme entscheiden sich Patienten für ein Jahr immer zuerst ihren Hausarzt aufzusuchen, der dann bei Bedarf die Behandlung mit anderen Ärzten, Kliniken und Physiotherapeuten koordiniert. Dadurch kann er alle Befunde in seiner Praxis sammeln und behält leichter den Überblick z.B. über die verschriebenen Medikamente.<br><br>
      So können Risiken, wie Neben- oder Wechselwirkungen unterschiedlicher Medikamente, vermieden werden.
    </div>
    <div class="desktopOnly" style="margin-top: 20px">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/D1mRE3oKrRI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    <div class="mobileOnly">
      <iframe width="300" height="200" src="https://www.youtube.com/embed/D1mRE3oKrRI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HausarztProgramm'
}
</script>

<style scoped>
.hausarzt-programm {
  background-color: #EFF1F3;
  padding: 30px;
}

.hzvLogo {
  width: 500px;
  height: 150px;
  background-size: cover;
  background-position: center center;
  background-image: url('../assets/images/HZVlogo.png');
}

  @media screen and (max-width: 700px) {
    .hzvLogo {
      display: inline-block;
      width: 300px;
      height: 80px;
    }
  }

  .hzvText {
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    max-width: 600px;
    padding: 40px;
  }

  @media screen and (max-width: 700px) {
    .hzvLogo {
      display: block;
    }
  }

  .newsImg {
    display: inline-block;
    vertical-align: middle;
    width: 600px;
    height: 600px;
    background-size: cover;
    background-position: center center;
    border-radius: 10px;
    border: none;
    background-image: url('../assets/images/news.jpg');
  }

  @media screen and (max-width: 700px) {
    .newsImg {
      display: inline-block;
      width: 300px;
      height: 300px;
    }
  }

</style>